import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ResponsiveShell from "../layouts/ResponsiveShell";
import ScrollToTop from "../shared/components/ScrollToTop";
import ProfileSubpageShell from "../layouts/ProfileSubpageShell";
import { PrivacyScreen, TermsScreen } from "../features/settings/LegalScreen";

import XDateScreen from "../features/home/XDateScreen";

const ReelsScreen = lazy(() => import("../features/reels/ReelsScreen"));
const ManageReelsScreen = lazy(() => import("../features/reels/ManageReelsScreen"));
const ProfileDetails = lazy(() => import("../features/profile/ProfileDetails"));
const MessagesScreen = lazy(() => import("../features/messages/MessagesScreen"));
const SignInScreen = lazy(() => import("../features/auth/screens/SignInScreen"));
const AuthScreen = lazy(() => import("../features/auth/screens/AuthScreen"));
const PhoneLoginScreen = lazy(() => import("../features/auth/screens/PhoneLoginScreen"));
const OTPScreen = lazy(() => import("../features/auth/screens/OTPScreen"));
const PerformerSetupScreen = lazy(() => import("../features/auth/screens/PerformerSetupScreen"));
const HostSetupScreen = lazy(() => import("../features/auth/screens/HostSetupScreen"));
const BuyCreditsScreen = lazy(() => import("../features/credits/BuyCreditsScreen"));
const VisibilityBoostsScreen = lazy(() => import("../features/credits/VisibilityBoostsScreen"));
const UserProfileScreen = lazy(() => import("../features/profile/screens/user-profile/UserProfileScreen"));
const AdminScreen = lazy(() => import("../features/admin/AdminScreen"));
const EditContactScreen = lazy(() => import("../features/profile/EditContactScreen"));
const SettingsScreen = lazy(() => import("../features/settings/SettingsScreen"));
const FriendzyScreen = lazy(() => import("../features/legacy/friendzy/FriendzyScreen"));

function BareLayout({ children, className = "" }) {
  return (
    <div className={`app-container${className ? ` ${className}` : ""}`}>
      <div className="content">{children}</div>
    </div>
  );
}

export default function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route element={<ResponsiveShell />}>
            <Route path="/" element={<XDateScreen />} />
            <Route path="/reels" element={<ReelsScreen />} />
            <Route path="/manage-reels" element={<ManageReelsScreen />} />
            <Route path="/profile-details" element={<ProfileDetails />} />
            <Route path="/user-profile" element={<UserProfileScreen />} />
            <Route path="/location" element={<Navigate to="/" replace />} />
            <Route path="/messages" element={<MessagesScreen />} />
            <Route path="/signin" element={<SignInScreen />} />
            <Route path="/register" element={<AuthScreen />} />
            <Route path="/auth" element={<AuthScreen />} />
            <Route path="/onboarding/*" element={null} />
            <Route
              path="/terms"
              element={(
                <ProfileSubpageShell>
                  <TermsScreen />
                </ProfileSubpageShell>
              )}
            />
            <Route
              path="/privacy"
              element={(
                <ProfileSubpageShell>
                  <PrivacyScreen />
                </ProfileSubpageShell>
              )}
            />
            <Route
              path="/buy-credits"
              element={(
                <ProfileSubpageShell>
                  <BuyCreditsScreen />
                </ProfileSubpageShell>
              )}
            />
            <Route
              path="/visibility-boosts"
              element={(
                <ProfileSubpageShell>
                  <VisibilityBoostsScreen />
                </ProfileSubpageShell>
              )}
            />
          </Route>

          <Route
            path="/profile/edit"
            element={(
              <BareLayout>
                <EditContactScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/settings"
            element={(
              <BareLayout>
                <SettingsScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/friends"
            element={(
              <BareLayout>
                <FriendzyScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/phone-login"
            element={(
              <BareLayout>
                <PhoneLoginScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/otp"
            element={(
              <BareLayout>
                <OTPScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/role-selection"
            element={(
              <BareLayout>
                <Navigate to="/onboarding/photos" replace />
              </BareLayout>
            )}
          />
          <Route
            path="/performer-setup"
            element={(
              <BareLayout>
                <PerformerSetupScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/host-setup"
            element={(
              <BareLayout>
                <HostSetupScreen />
              </BareLayout>
            )}
          />
          <Route
            path="/admin"
            element={(
              <BareLayout>
                <AdminScreen />
              </BareLayout>
            )}
          />
        </Routes>
      </Suspense>
    </>
  );
}
